<template>
  <div>
    <CommonPopup
      v-model="visible"
      title="筛选"
      class="interest_table_column"
      :height="scene === 'normal' ? '90%' : '50%'"
      round
      closeable
      position="bottom"
      get-container="body"
      :z-index="103"
      @close="visible = false"
      @confirm="confirm"
    >
      <div class="content">
        <dl v-for="item in interestItems" :key="item.key">
          <dt>
            <p>{{ item.name }}</p>
            <p
              v-if="item.key === 'bonus' ? values.bonus === 'PSUDO_OPTION_CUSTOM_RATE' : item.actionBtnTx"
              @click="onClickRightButton(item)"
            >
              <span>{{ item.actionBtnTx }}</span>
              <i v-if="item.actionBtnTx" class="iconfont icon-arrows_right" />
            </p>
          </dt>
          <dd
            v-for="o in item.options.filter(e => !e.hiddenFlag)"
            :key="item.key + (o.index || o.value)"
            :class="{
              active: isActiveOption(item, o)
            }"
            :data-stat-id="item.stat"
            :data-stat-ep="JSON.stringify({
              key: o.value,
              state: item.key === 'displayFields' ? values[item.key] && values[item.key].includes(o.value) ? 'qx' : 'tj' : undefined
            })"
            @click="onClickOption(item, o)"
            v-html="o.description"
          />
          
          <template v-if="item.key==='bonus'&&formData.formValues.bonus==='PSUDO_OPTION_CUSTOM_RATE'&&!isTerminalC">
            <InterestFormBonus
              :form-data="formData"
              :setting-name="'设置实现率'"
              :type="'bonus'"
              :step="1"
              :previous-bonus-custom-rate="bonusCustomRate"
              :max-bonus-custom-rate="maxBonusCustomRate"
              @update="data =>updateBonusCustomRate(item,data)"
            />
          </template>
          
          <!-- 当没有年金领取选项时，在红利领取后面显示组件 -->
          <template v-if="item.key==='bonusTake' && shouldShowBonusComponent && !hasPensionTake">
            <InterestFormBonus
              :form-data="formData"
              :setting-name="'设置利率'"
              :type="'acc'"
              :step="0.1"
              :previous-bonus-custom-rate="accRate"
              :max-bonus-custom-rate="5"
              @update="data => updateAccRate(item,data)"
            />
          </template>
          
          <!-- 在年金领取后面显示组件 -->
          <template v-if="item.key==='pensionTake' && shouldShowBonusComponent">
            <InterestFormBonus
              :form-data="formData"
              :setting-name="'设置利率'"
              :type="'acc'"
              :step="0.1"
              :previous-bonus-custom-rate="accRate"
              :max-bonus-custom-rate="5"
              @update="data => updateAccRate(item,data)"
            />
          </template>
        </dl>
      </div>
    </CommonPopup>

    <InterestFormRate
      v-model="ratePopupConfig.visible"
      :form-data="formData"
      :has-custom-rate="ratePopupConfig.hasCustomRate"
      :previous-rate="ratePopupConfig.cachePreviousRate"
      @update="rateConfirm"
    />
  </div>
</template>
<script>
import QS from 'qs'
import { Toast } from 'vant'
import { URL_PARAM } from 'common/utils/variables'
import { get as _get, cloneDeep } from 'lodash'
import { getInterestDetailWithRemark } from '@/pages/planbkTemplatev2/js/api'
import { CACHE_DETAIL_DATA_WITH_REMARK } from '../constant'

import CommonPopup from '@/components/common/common-popup/index.vue'
import InterestFormRate from './interest-form-rate.vue'
import InterestFormBonus from './interest-form-bonus.vue';

const { pbType, isShareFormWeApp, shareFrom } = URL_PARAM
export default {
  components: {
    CommonPopup,
    InterestFormRate,
    InterestFormBonus
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    interestFieldOptions: {
      type: Array,
      default: () => ([])
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    backupAddAndTakeData: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
    interestDetailRequestParams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      scene: 'normal', // normal | export
      values: null,
      interestDetailData: null,
      backupFormData: null,
      ratePopupConfig: this.initRatePopupConfig(),
      isClickConfirm: false,
      bonusPopupConfig: this.initBonusPopupConfig(),
      bonusCustomRate:null,
      accRate:null
    }
  },
  computed: {
    isTerminalC(){
      return isShareFormWeApp || shareFrom
    },
    maxBonusCustomRate() {
      return 200
    },
    interestItems () {
      const { interestFieldOptions, interestDetailData } = this
      const items = cloneDeep(interestFieldOptions) || []

      items.forEach(item => {
        if (item.key === 'rate') {
          if (item.options) {
            item.options = item.options.filter(o => o.index !== -1)
          }
        }
        // 切换不同分红、利率、分红领取等信息，需要更新字段选项。From hyw
        if (item.key === 'displayFields') {
          const { _nonmainCalculationFields } = item
          if (_get(interestDetailData, 'length')) {
            const userShowInterestKeyList = interestDetailData.filter(e => e.userShow).map(e => e.key)
            const options = interestDetailData
              .map(e => ({
                value: e.key,
                description: e.name || e.key
              }))
              .filter(e => userShowInterestKeyList.length ? userShowInterestKeyList.includes(e.value) : !_nonmainCalculationFields.includes(e.value))
            item.options = options
          }
        }
      })
      return items
    },
    visible: {
      get () {
        if (this.value) {
          this.backupFormData = cloneDeep(this.formData)
        }
        return this.value
      },
      set (v) {
        if (!v) {
          const { backupFormData, isClickConfirm, backupAddAndTakeData } = this
          if (!isClickConfirm) {
            let values = {
              isShowFieldPopup: false
            }
            if (backupFormData) {
              const { formValues, addAndTakeData, customRate, drawData, duplicateDrawData } = backupFormData
              values = cloneDeep({
                ...formValues,
                addAndTakeData,
                customRate,
                drawData,
                duplicateDrawData,
                isShowFieldPopup: false
              })
            }
            if (backupAddAndTakeData) {
              const { addAndTakeData, drawData, duplicateDrawData } = backupAddAndTakeData
              if (addAndTakeData) {
                values.addAndTakeData = addAndTakeData
              }
              if (drawData) {
                values.drawData = drawData
              }
              if (duplicateDrawData) {
                values.duplicateDrawData = duplicateDrawData
              }
            }
            this.$emit('confirm', values)
          }
          this.scene = 'normal'
          this.isClickConfirm = false
        }
      }
    },
    hasBonusTake() {
      return this.interestItems.some(o => o.key === 'bonusTake')
    },
    hasPensionTake() {
      return this.interestItems.some(o => o.key === 'pensionTake')
    },
    shouldShowBonusComponent() {
      const { formValues } = this.formData
      const hasBonusAccumulation = formValues.bonusTake === 'bonus_acc'
      const hasPensionAccumulation = formValues.pensionTake === 'annuity_acc'
      return this.hasBonusTake && this.hasPensionTake 
        ? (hasBonusAccumulation || hasPensionAccumulation) 
        : (this.hasBonusTake && hasBonusAccumulation) || (this.hasPensionTake && hasPensionAccumulation)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        if (v) {
          this.getInterestDetail()
        }
      }
    },
    'formData.formValues': {
      deep: true,
      immediate: true,
      handler (v) {
        this.values = v
        this.bonusCustomRate = v.bonusCustomRate||Number(v.bonusCustomRate)||null
        this.accRate = v.accRate||null
      }
    },
  },
  methods: {
    async getInterestDetail () {
      const { interestDetailRequestParams, values } = this
      const requestParams = cloneDeep(interestDetailRequestParams)
      if (requestParams) {
        const keys = ['bonus', 'rate', 'bonusTake']
        keys.filter(k => requestParams[k]).forEach(k => {
          if (k === 'rate' && values.rateIndex === -1) {
            return
          }
          if (k === 'bonus') {
            requestParams[k] = {
              value: values[k] === 'PSUDO_OPTION_CUSTOM_RATE' ? 'mid' : values[k]
            }
            return
          }
          requestParams[k] = {
            value: values[k]
          }
        })
        requestParams.drawFlag = values.drawFlag
        requestParams.addAndTakeFlag = values.addAndTakeFlag
      }
      const cacheKey = QS.stringify(requestParams)
      const cacheData = CACHE_DETAIL_DATA_WITH_REMARK[cacheKey]
      if (cacheData) {
        this.interestDetailData = cacheData.dataList
      } else {
        this.interestDetailData = await getInterestDetailWithRemark(requestParams, pbType === 'annual_survey').then((res) => {
          const { success, data, info } = res.data
          if (success && data) {
            if (data.dataList) {
              data.dataList.forEach(d => {
                if (!['irr_value', 'single_value', 'policy_cash_grow_rate', 'annuity_year_per_baof'].includes(d.key)) {
                  if (d.values) {
                    d.values = d.values.map(v => v ? Math.round(v) : v)
                  }
                }
              })
            }
            CACHE_DETAIL_DATA_WITH_REMARK[cacheKey] = data
          } else {
            Toast(info || '接口异常')
          }
          return Promise.resolve(data.dataList)
        })
      }
    },
    initRatePopupConfig() {
      return {
        visible: false,
        hasCustomRate: null,
        cachePreviousRate: null
      }
    },
    initBonusPopupConfig() {
      return {
        visible: false,
        cachePreviousRate: null
      }
    },
    isActiveOption (item, o) {
      const { formData, values } = this
      let bool = values[item.key] === o.value
      if (values[item.key] && values[item.key].constructor === Array) {
        bool = values[item.key].includes(o.value)
      }

      if (['rate'].includes(item.key)) {
        const { rateIndex } = values
        bool = o.index === rateIndex || (rateIndex === -1 && Math.abs(formData.customRate - o.value) < 1e-5)
      }
      if (['addAndTakeData'].includes(item.key)) {
        bool = values.addAndTakeFlag === o.value
      }
      if (['drawData'].includes(item.key)) {
        bool = values.drawFlag === o.value
      }
      return bool
    },
    onClickRightButton (item) {
      const self = this
      const { formValues } = self.formData
      if (item.key === 'rate') {
        self.ratePopupConfig = {
          visible: true,
          hasCustomRate: item.hasCustomRate,
          cachePreviousRate: formValues.rate ? Number(formValues.rate) : null
        }
        return
      }
      if(item.key === 'bonus' && item.actionBtnTx == '设置红利实现率') {
        self.bonusPopupConfig = {
          visible: true,
          cachePreviousRate: formValues.bonusCustomRate ? Number(formValues.bonusCustomRate) : null
        }
      }
      if (['addAndTakeData', 'drawData'].includes(item.key)) {
        self.$parent.openAddAndTakePicker(item)
      }
      if (['singleCalType'].includes(item.key)) {
        self.$parent.isShowSingleValueAlgoPopup = true
      }
    },
    onClickOption (item, o) {
      const { scene, values } = this
      if (['drawData', 'addAndTakeData'].includes(item.key) || Array.isArray(values[item.key]) || ['rate'].includes(item.key)) {
        if (['drawData'].includes(item.key)) {
          values.drawFlag = o.value
        }
        if (['addAndTakeData'].includes(item.key)) {
          values.addAndTakeFlag = o.value
        }
        if (Array.isArray(values[item.key])) {
          const set = new Set(values[item.key] || [])
          if (set.has(o.value)) {
            if (set.size > 1) {
              set.delete(o.value)
            }
          } else {
            set.add(o.value)
          }
          values[item.key] = [...set]
          if (scene === 'export') {
            if (item.key === 'displayFields') {
              this.$emit('confirm', cloneDeep(values))
            }
          }
        }
  
        if (['rate'].includes(item.key)) {
          if (o.index !== -1) {
            values.rateIndex = o.index
            values[item.key] = o.value
          }
        }
      } else {
        values[item.key] = o.value
      }
      if (['bonus', 'rate', 'drawData', 'addAndTakeData', 'bonusTake'].includes(item.key)) {
        this.getInterestDetail()
      }
    },
    rateConfirm (data) {
      if (data) {
        this.$emit('confirm', {
          ...data,
          isShowFieldPopup: true
        })
        this.ratePopupConfig = this.initRatePopupConfig()
      }
    },
    updateBonusCustomRate(item,data) {
      item.options[item.options.length-1].description = `红利实现率 ${data.bonusCustomRate}%`
      if (data) {
        this.$emit('confirm', {
          ...data,
          isShowFieldPopup: true
        })
        this.bonusPopupConfig = this.initBonusPopupConfig()
      }
    },
    updateAccRate(item, data) {
      const accRateValue = data.accRate > 0.05 ? 0.05 : data.accRate
      this.$emit('confirm', {
        ...this.values,
        accRate: accRateValue,
        isShowFieldPopup: true
      })
    },
    confirm () {
      this.isClickConfirm = true
      this.visible = false
      this.$emit('confirm', cloneDeep({
        ...this.values,
        isShowFieldPopup: false
      }))
    }
  }
}
</script>
<style>
@import './interest-show-fields.css';
</style>
